
  <section style="background-color: #c7ebc8;">
    <div class="container-lg">
      <div class="row d-flex justify-content-lg-between justify-content-center align-items-center mt-5">
        <div class="col-lg-5 py-3">
          <div class="py-4">
            <p class="fs-2 text-black fw-semibold " style="line-height: normal;">
              Supercharge Your Business Conversations with Official WhatsApp API by Geti<span style="color: #4EB955">kk</span>
            </p>
            <p class="fs-6 text-muted">
              Engage, support, and convert customers 3X faster using <br>
              WhatsApp – all from one powerful platform.
            </p>
            <button class="btn btn-success btn-sm px-4">
            Get Free Demo
              <span class="material-symbols-outlined align-middle">arrow_forward</span>
            </button>
          </div>
        </div>
        <div class="col-lg-7 col-sm-10 d-flex justify-content-lg-end justify-content-center">
          <img src="../../assets/img/chat1.png" alt="" >
        </div>
      </div>
    </div>
  </section>
  <section class="py-5 my-1">
    <div class="container-lg">
      <div class="row d-flex justify-content-lg-between align-items-center mt-2 mb-2">
        <div class="col-lg-5">
            <p class="fs-4 fw-semibold text-black" style="line-height: normal;">
              Connect with Your Customers Through WhatsApp
            </p>
            <p class=" text-muted text-start" style="line-height: normal; font-size: 14px;">
              Leverage the power of the WhatsApp Business API to elevate customer 
              engagement. With Getikk’s seamless integration, connect with your
              audience efficiently, effectively, and effortlessly.
            </p>
        </div>
        <div class="col-lg-7 col-10 text-end d-flex justify-content-end">
           <img src="../../assets/img/home-2.png" alt=""  class="ps-5" class="h-1000px">
        </div>

      </div>
    </div>
  </section>
  <section class="py-5">
    <div class="container-lg">
      <div class="row align-items-center justify-content-center ">
        <div class="col-lg-7 col-10 text-end d-flex justify-content-end ">
            <img src="../../assets/img/home-3.svg" alt="" class="ps-5" class="h-1000px">
        </div>

        <div class="col-lg-5 py-3 " style="line-height: normal;">
          <div class="p-4">
            <h2 class="fs-4 fw-semibold text-black">
              Effortless Bulk Messaging
            </h2>
            <p class="text-muted "style="line-height: normal; font-size: 14px;">
              Reach out to your customers with personalized bulk messages. Whether
              it's promotional content, updates, or notifications, Getikk ensures your
              messages are delivered promptly, fostering better engagement and higher conversion rates.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-5 my-1">
    <div class="container-lg">
      <div class="row d-flex justify-content-lg-between align-items-center mt-2 mb-2">
        <div class="col-lg-5">
            <h2 class="fs-4 fw-semibold text-black" style="line-height: normal;">
              Round-the-Clock Customer Support
            </h2>
            <p class="text-muted text-start" style="line-height: normal; font-size: 14px;">
              Provide your customers with 24/7 support using our intelligent WhatsApp chatbot.
              Automate responses to common queries,
              allowing your support team to focus on more complex issues and ensuring your customers receive timely
              assistance.
            </p>
        </div>
        <div class="col-lg-7 col-10 text-end d-flex justify-content-end">
            <img src="../../assets/img/home-4.svg" alt="" class="ps-5" class="h-1000px">
        </div>
      </div>
    </div>
  </section>
  <section class="py-5 my-1">
    <div class="container-lg">
      <div class="row d-flex justify-content-lg-between align-items-center mt-2 mb-2">
        <div class="col-lg-7 col-10 text-end d-flex justify-content-end">
            <img src="../../assets/img/home-5.svg" alt=""class="ps-5" class="h-1000px">
        </div>
        <div class="col-lg-5">
            <h2 class="fs-4 fw-semibold text-black" style="line-height: normal;">
              Engaging Marketing Campaigns and Timely Notifications 
            </h2>
            <p class="text-muted  text-start "style="line-height: normal; font-size: 14px;">
              Keep your audience informed with targeted marketing campaigns and transactional messages.
              From new product launches to order confirmations, Getikk helps you maintain consistent and meaningful
              communication with your customers.
            </p>
        </div>
      </div>
    </div>
  </section>
  <section class="py-5 my-1">
    <div class="container-lg">
      <div class="row d-flex justify-content-lg-between align-items-center mt-2 mb-2">
        <div class="col-lg-4">
            <h2 class="fs-4 fw-semibold text-black" style="line-height: normal;">
              Cost-Free Messaging Within 24 Hours 
            </h2>
            <p class="text-muted text-start" style="line-height: normal; font-size: 14px;">
              Take advantage of WhatsApp's 24-hour messaging window to communicate with your customers at no additional
              cost.
              Respond to inquiries and send follow-up messages within this period to maintain engagement without
              incurring extra charges.
            </p>
        </div>
        <div class="col-lg-8 col-10 text-end d-flex justify-content-end">
            <img src="../../assets/img/home-6.svg" alt=""  class="ps-5" class="h-1000px">
        </div>
      </div>
    </div>
  </section>
  <section class="py-5">
    <div class="container" >
      <h3 class="text-center fw-semibold mb-5 text-black fs-4">
        Streamlined WhatsApp Communication with Getikk
      </h3>
      <div class="row g-4 justify-content-center text-center mb-2">
        <div class="col-md-3  text-center">
          <div class="card borderRoundedGreen rounded-4 p-4 h-100 bg-white shadow-sm">
            <div class="mb-3 fs-3 text-warning">
              <span class="fs-1 material-symbols-outlined">currency_rupee_circle</span>
            </div>
            <h5 class="fw-bold fs-6 mb-2">No Setup Fees</h5>
            <p class="text-black">Integrate WhatsApp into your business operations without any initial costs.</p>
          </div>
        </div>

        <div class="col-md-3 text-center">
          <div class="card borderRoundedGreen rounded-4  p-4 h-100 bg-white shadow-sm">
            <div class="mb-3 fs-3 chatColor">
              <span class="fs-1 material-symbols-outlined">check_circle</span>
            </div>
            <h5 class="fw-bold fs-6 mb-2">Pre-Approved Message Templates</h5>
            <p class="text-black">Utilize ready-made templates to initiate conversations seamlessly.</p>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card borderRoundedGreen rounded-4  p-4 h-100 bg-white shadow-sm">
            <div class="mb-3 fs-3 color">
              <span class="fs-1 material-symbols-outlined">robot_2</span>
            </div>
            <h5 class="fw-bold fs-6 mb-2">Automated Chatbots</h5>
            <p class="text-black">Enhance customer service with intelligent automation.</p>
          </div>
        </div>
      </div>
      <div class="row g-4 justify-content-center text-center">
        <div class="col-md-3  text-center">
          <div class="card  borderRoundedGreen rounded-4 p-4 h-100 bg-white shadow-sm">
            <div class="mb-3 fs-3 chatColor"><span class="fs-1 material-symbols-outlined">
              chat
              </span></div>
            <h5 class="fw-bold fs-6 mb-2">Free 24-Hour Chat Window</h5>
            <p class="text-black">Pay only for the messages you send beyond the free 24-hour window.</p>
          </div>
        </div>

        <!-- Box 5 -->
        <div class="col-md-3">
          <div class="card  borderRoundedGreen rounded-4 p-4 h-100 bg-white shadow-sm">
            <div class="mb-3 fs-3 color"><span class=" fs-1 material-symbols-outlined"> 3p</span></div>
            <h5 class="fw-bold fs-6 mb-2">Quick Integration and Support</h5>
            <p class="text-black">Get started swiftly with our easy setup process and access our support team anytime.</p>
          </div>
        </div>

        <!-- Box 6 -->
        <div class="col-md-3">
          <div class="card   borderRoundedGreen rounded-4 p-4 h-100 bg-white shadow-sm">
            <div class="mb-3 fs-3 colorPace"><span class="fs-1 material-symbols-outlined">
              pace
              </span></div>
            <h5 class="fw-bold fs-6  mb-2">WhatsApp Scheduler</h5>
            <p class="text-black">Schedule Broadcasts up to 2 months ahead of time across varying timezones.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
<section class="py-5 bg-white">
  <div class="container-lg">
    <div class="text-center mb-5">
      <h4 class="fw-semibold fs-4">Why Choose WhatsApp Business API?</h4>
      <p class="text-black" >
        For medium to large businesses, the WhatsApp Business API offers advanced features
        beyond the standard WhatsApp and WhatsApp Business apps:
      </p>
    </div>

    <div class="row g-4 justify-content-center text-center">
      <!-- Standard WhatsApp -->
      <div class="col-md-3">
        <div class="card  border_green rounded-4 p-4 h-100 bg-white shadow-sm">
          <div class="mb-3">
            <img src="../../assets/img/whatsapp-1.svg" alt=" " class="img-fluid" style="height: 48px;">
          </div>
          <h6 class="fw-bold fs-6">Standard WhatsApp</h6>
          <p class="text-black "style="font-size: 12px;">
            Designed for personal use with limited business functionalities.
          </p>
        </div>
      </div>

      <!-- WhatsApp Business App -->
      <div class="col-md-3">
        <div class="card border_green rounded-4 p-4 h-100 bg-white shadow-sm">
          <div class="mb-3">
            <img src="../../assets/img/whatsapp-2.svg" alt="" class="img-fluid" style="height: 48px;">
          </div>
          <h6 class="fw-bold fs-6">WhatsApp Business App</h6>
          <p class="text-black "style="font-size: 12px;">
            Suitable for small businesses but lacks capabilities like bulk messaging and multi-agent support.
          </p>
        </div>
      </div>

      <!-- WhatsApp Business API -->
      <div class="col-md-3">
        <div class="card border_green rounded-4 p-4 h-100 text-white shadow-sm  custom-green">
          <div class="mb-3">
            <img src="../../assets/img/whatsapp-3.svg" alt="Business API" class="img-fluid" style="height: 48px;">
          </div>
          <h6 class="fw-bold fs-6 text-white">WhatsApp Business API</h6>
          <p class="text-white  "style="font-size: 12px;">
            Ideal for businesses aiming to automate campaigns and manage customer
            communications at scale with multiple team members.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

  <section class="py-5">
    <div class="container-lg">
      <div class="text-center mb-2">
        <h4 class="fw-semibold fs-4">Integrate Forms, Payments & Click-to-WhatsApp Ads</h4>
        <p class="text-black fs-6">
          Supercharge your jewellery business with smart WhatsApp integrations
        </p>
      </div>
      <div class="row d-flex justify-content-lg-between align-items-center mt-2 mb-2">
        <div class="col-lg-5 ">
          <div class="p-4">
            <h2 class="fs-4 fw-semibold mb-4">
              AI-Powered Click-to-WhatsApp Ads
            </h2>
            <p class=" text-muted "style="line-height: normal; font-size: 14px;">
              Attract potential buyers with targeted ads that lead directly to a WhatsApp conversation — ideal for
              promoting new collections, festive offers, or bridal jewellery.
            </p>
          </div>
        </div>
        <div class="col-lg-7 col-10 text-end d-flex justify-content-end">
         <img src="../../assets/img/home-7.svg" alt=""  class="ps-5" class="h-1000px">
          </div>
      </div>
    </div>
  </section>
  <section class="py-5">
    <div class="container">
      <div class="row align-items-center justify-content-center ">
        <div class="col-lg-7 col-10 text-center mt-4 ">
          <div class="p-4">
            <img src="../../assets/img/home-8.svg" alt="" class="img-fluid" style="max-height: 500px;">
          </div>
        </div>
        <div class="col-lg-5 py-3 order-lg-2 order-2">
          <div class="p-4">
            <h2 class="fs-3 fw-semibold mb-4">
              Interactive WhatsApp Forms
            </h2>
            <p class="fs-6 text-muted mb-4">
              Effortlessly collect customer details for appointments, event RSVPs, or custom design requests — all
              within the chat.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-5">
    <div class="container-lg">
      <div class="row d-flex justify-content-lg-between align-items-center mt-2 mb-2">
        <div class="col-lg-5 py-3 ">
            <h2 class="fs-4 fw-semibold text-black" style="line-height: normal;">
              In-Chat Payments
            </h2>
            <p class=" text-muted text-start" style="line-height: normal; font-size: 14px; ">
              Enable secure payments right inside WhatsApp for bookings, advance payments, or product orders, offering
              unmatched convenience to your customers.
            </p>
        </div>
        <div class="col-lg-7 col-10 text-end d-flex justify-content-end">
          <div class="p-4">
            <img src="../../assets/img/home-9.svg" alt="" class="ps-5" class="h-1000px">>
          </div>
        </div>

      </div>
    </div>
  </section>
  <section class="py-5 bg-white">
    <div class="container text-center">
      <h3 class="fw-bold mb-2 fs-4">Why WhatsApp Marketing?</h3>
      <p class="text-black mb-5">
        WhatsApp is the one platform that brings together actionable notifications & customer support!
      </p>
      <div class="row g-4 justify-content-center">
        <div class="col-6 col-md-3">
          <div class="border rounded p-4 shadow-sm h-100">
            <h4 class="fw-bold mb-1 fs-3">98%</h4>
            <p class="text-muted mb-0">Open Rates</p>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="border rounded p-4 shadow-sm h-100">
            <h4 class="fw-bold mb-1 fs-3">45-60%</h4>
            <p class="text-muted mb-0">Click Rates</p>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="border rounded p-4 shadow-sm h-100">
            <h4 class="fw-bold mb-1 fs-3">2.60Bn+</h4>
            <p class="text-muted mb-0">Active Users</p>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="border rounded p-4 shadow-sm h-100">
            <h4 class="fw-bold mb-1 fs-3">70%</h4>
            <p class="text-muted mb-0">Engagement Rate</p>
          </div>
        </div>

      </div>
    </div>
  </section>
